import React from "react";

const BagIcon = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.016 5.58789C16.0517 5.51107 16.0684 5.42734 16.0649 5.34326H16.0943C15.9687 2.45074 13.494 0.167969 10.4839 0.167969C7.47379 0.167969 4.9991 2.45074 4.87349 5.34326C4.85868 5.42418 4.85868 5.50697 4.87349 5.58789H4.78568C3.34632 5.58789 1.8077 6.50491 1.361 8.97L0.487457 15.6849C-0.22726 20.6151 2.40329 21.8477 5.8379 21.8477H15.1491C18.5738 21.8477 21.1249 20.0629 20.4896 15.6849L19.626 8.97C19.0999 6.57393 17.6109 5.58789 16.1914 5.58789H16.016ZM14.4019 5.58789C14.3706 5.50978 14.354 5.42695 14.3529 5.34326C14.3529 3.26472 12.601 1.57973 10.4399 1.57973C8.27872 1.57973 6.52677 3.26472 6.52677 5.34326C6.54158 5.42418 6.54158 5.50697 6.52677 5.58789H14.4019ZM7.2177 11.1689C6.66947 11.1689 6.22504 10.7274 6.22504 10.1828C6.22504 9.63825 6.66947 9.19679 7.2177 9.19679C7.76594 9.19679 8.21037 9.63825 8.21037 10.1828C8.21037 10.7274 7.76594 11.1689 7.2177 11.1689ZM12.727 10.1828C12.727 10.7274 13.1714 11.1689 13.7196 11.1689C14.2679 11.1689 14.7123 10.7274 14.7123 10.1828C14.7123 9.63825 14.2679 9.19679 13.7196 9.19679C13.1714 9.19679 12.727 9.63825 12.727 10.1828Z"
        fill="#FF8F6B"
      />
    </svg>
  );
};

export default BagIcon;
